/**
 *
 * @param {BoundsProps} bounds
 * @param {Number} pointer
 * @param {"width" | "height"} dimension
 * @param {"right" | "left" | "top" | "bottom"} side
 * @param {Number | null} amount
 * @param {Boolean} higher
 * @param {Number} type
 * @returns
 */
const getPointerSelfPosition = (
  bounds,
  pointer,
  dimension,
  side,
  amount,
  higher,
  type
) => {
  const size = /** @type {Number} */ (bounds.get(dimension));
  const offset = /** @type {Number} */ (bounds.get(`viewport-${side}`));
  const boundsSide = offset - size / 2;
  const threshold = amount === null ? boundsSide : amount - size / 2;
  const right = /** @type {Number} */ (bounds.get(side));
  const position = higher ? right - size / 2 : right + size / 2;
  const add = type === 1 ? 1 : 0;

  if (type) {
    return (pointer - position) / (threshold + size) + add;
  } else {
    return 1 - Math.abs((pointer - position) / (threshold + size));
  }
};

export default getPointerSelfPosition;
